import {
  Select,
  Option,
  Message, //消息提示组件
  Pagination, //分页组件
  Carousel,
  CarouselItem,
  Card,
  Input,
  Button
} from 'element-ui'
// 按需引入Element插件  借助 babel-plugin-component
const element = {
  install: function (Vue) {
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Pagination)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    Vue.use(Card)
    Vue.use(Input)
    Vue.use(Button)
    Vue.prototype.$message = Message
  }
}

export default element



// WEBPACK FOOTER //
// ./src/element-ui/index.js